export default "__VITE_ASSET__MBv8JcB___"